export default __webpack_public_path__ + "static/jersey-01-78cb6e7ecd8b0fef445de5f1b61ad33b.jpg";